import React from 'react';
import { useCookieConsent } from 'contexts/CookieConsentContext';
import './CookieConsent.css';

function CookieConsent() {
  const { consent, acceptCookies, declineCookies } = useCookieConsent();

  if (consent !== null) return null;

  return (
    <div className="cookie-banner">
      <p className="cookie-text">
        Ce site utilise des cookies pour améliorer votre expérience.
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn-decline" onClick={declineCookies}>
          Refuser
        </button>
        <button className="cookie-btn cookie-btn-accept" onClick={acceptCookies}>
          Accepter
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
